import { checkLoginToken } from './serve';
/**
 * 加密工具方法
 */
import encryptFactory from '@igc-lib/encrypter';
// 公钥字符串
const PUBLIC_KEY = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3hBYP7XV8YyDU9IHLeu15PFdWM6sQfanoUuPDTkDh0gZPAqc13uk1QHQTuzfELacfcjE4GmVn9bi9IP2C+1Kr0L0EBrq1Awch+oSTGKh9BXoUvw2PvuBwYzcywflGBOLtO0VhdQbRcxr+jtnE/iCSu29ETHZHcqv27W+KSK9UpQIDAQAB`;

export const RSAEncryptInstance = (source) => {
  const RSAEncryptInstance = encryptFactory('RSA', { publicKey: PUBLIC_KEY });
  const result = RSAEncryptInstance.encrypt(source);
  return result;
};

/**
 * @params 少年得到 用来存储登录信息
 *
 */
const TOKEN_KEY = 'IGetCool-USER-Info';

export const setUserInfo = (info, _key = '') => {
  localStorage.setItem(`${TOKEN_KEY}${_key}`, JSON.stringify(info));
};

export const getUserInfo = (_key = '') => {
  return localStorage.getItem(`${TOKEN_KEY}${_key}`);
};

export const removeUserInfo = (_key = '') => {
  localStorage.removeItem(`${TOKEN_KEY}${_key}`);
};

export const CheckLoginStatus = (options) => {
  return new Promise(async (resolve, reject) => {
    try {
      let params;
      if (options) {
        params = options;
      } else {
        const userInfo = JSON.parse(getUserInfo());
        if (userInfo) {
          const {
            token,
            uid
          } = userInfo;
          params = {
            token: token,
            userId: uid
          };
        }
      }
      if (params) {
        const res = await checkLoginToken(params);
        if (res.code === 10000) {
          resolve(res.data);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    } catch (error) {
      reject(error);
    }
  });
};
